import React from 'react'
import { Row, Col, Typography, Button } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'
import styles from './ResponseListHeader.module.scss'
import { useTranslation } from 'next-i18next'

const ResponseListHeader = (props: any) => {
  const { length, loading, handleCsvDownload } = props
  const { t } = useTranslation()

  return (
    <Row>
      <Col xs={24} lg={12}>
        <Typography.Title level={5} type='secondary'>
          {t('general.Results')} (<strong>{length}</strong>)
        </Typography.Title>
      </Col>
      <Col xs={24} lg={12}>
        {handleCsvDownload && (
          <Button
            className={`${styles['margin-button']} float-right radius-100`}
            type='primary'
            disabled={loading}
            icon={<DownloadOutlined />}
            onClick={handleCsvDownload}
          >
            {t('general.DownLoadCSV')}
          </Button>
        )}
      </Col>
    </Row>
  )
}

export default ResponseListHeader
